<div class="subtitle pt-2 px-2">{{ 'general.charts.symptoms_yes_no.subtitle' | translate }}</div>
<div class="chart-wrapper py-2">
  <canvas [class.empty]="!data?.length" id="symptonsYesNoBarChart"></canvas>
  <div class="chart-empty" *ngIf="!data?.length">
    {{ 'general.charts.empty_message' | translate }}
  </div>
</div>
